export default "__VITE_ASSET__CDBOr_wo__"